import React, { useState } from 'react';
import styled from 'styled-components';

const StoryStyle = styled.div`
	background-color: #fff;
	.flex {
		display: flex;
		color: #fff;
		background-color: ${(p) => p.theme.color.dark};
		margin-bottom: 1rem;
		&:last-child {
			margin-bottom: 0;
		}
		.photo-col {
			display: flex;
			justify-content: space-between;
			flex-direction: column;
			width: 30%;
			background-color: ${(p) => p.theme.color.teal};
			.img-wrap img {
				width: 100%;
			}
			.text {
				padding: 2rem;
				p {
					margin-bottom: 0.5rem;
				}
				a {
					font-weight: 700;
					position: relative;
					span {
						position: relative;
						left: 0;
						transition: 0.3s left;
						color: ${(p) => p.theme.color.green};
						margin-left: 5px;
					}
					&:hover span {
						left: 0.5rem;
					}
				}
			}
		}
		.text-col {
			width: 70%;
			padding: 4rem 4rem 3rem;
			background-color: ${(p) => p.theme.color.dark};
			h2 {
				font-weight: 700;
				margin-bottom: 2rem;
			}
			p {
				margin-bottom: 1.5rem;
				&.large {
					font-size: 1.2rem;
					line-height: 1.7rem;
				}
			}

			.mobile-more {
				display: none;
			}
			button {
				padding: 0.3rem 0.5rem 0.3rem 0;
				font-size: 1rem;
				position: relative;
				img {
					transform: rotate(0deg);
					transition: transform 0.3s;
					display: inline-block;
					height: 17px;
					width: 17px;
					position: relative;
					top: 2px;
					left: 3px;
				}
				&.show {
					padding-right: 0.5rem;
					img {
						transform: rotate(90deg);
					}
				}
			}

			.more-container {
				&.hideMore {
					display: none;
				}

				p.more {
					margin-top: 1rem;
					margin-bottom: 0;
					display: none;
					&.show {
						display: block;
					}
				}
			}
		}
		@media all and (max-width: 768px) {
			flex-direction: column-reverse;
			.text-col {
				width: 100%;
				padding: 4rem 2rem 2rem;

				p {
					/* margin-bottom: 0; */
					&.large {
						font-size: 1rem;
					}
				}
				.mobile-hide {
					display: none;
				}
				.mobile-more {
					display: block;
				}
				button {
					margin: 1rem 0;
				}
				.more-container {
					.desktop-more {
						display: none;
					}
				}
			}
			.photo-col {
				width: 100%;
				background-color: ${(p) => p.theme.color.dark};
				img {
					max-width: 400px;
				}
				.text {
					background-color: ${(p) => p.theme.color.teal};
				}
			}
		}
		@media all and (max-width: 450px) {
			.photo-col img {
				max-width: 100%;
			}
		}
	}
`;

export default () => {
	const [showMore, setShowMore] = useState(
		new Array(stories.length).fill(false)
	);

	const toggleReadMore = (index) => {
		let temp = [...showMore];
		temp[index] = !temp[index];
		setShowMore(temp);
	};

	return (
		<StoryStyle>
			{stories.map((item, index) => (
				<div className="flex" id={item.id} key={index}>
					<div className="photo-col">
						<div className="img-wrap">
							<img src={item.img.src} alt={item.img.alt} />
						</div>
						<div className="text">
							<p>Learn more about</p>
							<a
								target="_blank"
								rel="noopener noreferrer"
								href={item.link.href}
							>
								{item.link.text}
								<span>></span>
							</a>
						</div>
					</div>
					<div className="text-col">
						<h2>{item.title}</h2>
						<p className="large">{item.largeContent}</p>
						<button
							className={showMore[index] ? 'show mobile-more' : 'mobile-more'}
							onClick={() => toggleReadMore(index)}
						>
							READ MORE
							<img src="/img/arrow.svg" alt="arrow" />
						</button>
						<div className={showMore[index] ? '' : 'mobile-hide'}>
							<p>{item.smallContent}</p>
							{item.readMore && <p>{item.readMore}</p>}
						</div>
						<div
							className={
								item.desktopMore ? 'more-container' : 'hide more-container'
							}
						>
							<button
								className={
									showMore[index] ? 'show desktop-more' : 'desktop-more'
								}
								onClick={() => toggleReadMore(index)}
							>
								READ MORE
								<img src="/img/arrow.svg" alt="arrow" />
							</button>
							<p className={showMore[index] ? 'more show' : 'more'}>
								{item.readMore}
							</p>
						</div>
					</div>
				</div>
			))}
		</StoryStyle>
	);
};

const stories = [
	{
		title: "Alex's Story",
		id: 'alex',
		desktopMore: false,
		img: {
			src: '/img/Alex.jpg',
			alt: 'alex headshot',
		},
		link: {
			text: 'Mental Health Awareness',
			href: 'https://ontario.cmha.ca/mental-health/',
		},
		largeContent:
			'For the majority of us, making our own decisions and having a home of our own are taken for granted. However for some it is almost an unfeasible dream never reached due to mental health barriers. Alex had been living with serious mental health issues for many years and has lived in numerous residential settings including supervised facilities, while rarely being able to maintain independent living.',
		smallContent:
			'Alex had been psychiatrically hospitalized many times and had lost custody of her children due to being “labelled” unfit to parent. Alex was receiving no support from family and friends and was left to deal with life on her own. Alex was connected with CARAH, the CMHA Crisis Program, due to being homeless, not receiving any regular physician care, unable to care for herself and with a hopeless attitude about life. During her stay with CARAH she developed a positive rapport with the staff through supportive counselling and began to change her outlook on life in a short time. Alex was able to secure housing and obtain a family doctor with the support of an outreach case manager. With her newly stable environment and supportive counselling Alex is beginning to get back on the right track and is working to gain visitation rights to her children. Alex shared she has many goals to accomplish such as finding employment and upgrading her education. However by taking each day one at a time, her future is looking brighter with each passing day.',
	},
	{
		title: "John's Story",
		id: 'john',
		desktopMore: false,
		img: {
			src: '/img/John.jpg',
			alt: 'John headshot',
		},
		link: {
			text: 'Addictions Awareness',
			href: ' https://ontario.cmha.ca/addictions/',
		},
		largeContent:
			'In 2012, when John moved to Ontario he reported “feeling broken”. For as long as he could remember, John struggled with addiction and depression resulting in a life of homelessness.',
		smallContent:
			'Today John can say he has abstained from alcohol for 2 years and has been able to manage his depression. John reports this is remarkable given that he had struggled for much of his 30 years with both of the diseases. John is grateful for the compassionate support and direction from CMHA. They not only helped him rebuild a solid foundation but gave him the tools to do so, in a respectful and kind manner. John continues to attend support groups and connect with his psychiatrist with success. Today John is proud to report he continues to maintain an apartment, work part time and volunteer with the community.',
	},
	{
		title: "Maria's Story",
		id: 'maria',
		desktopMore: false,
		img: {
			src: '/img/Kayley.jpg',
			alt: 'Maria headshot',
		},
		link: {
			text: 'Suicide Awareness',
			href:
				' https://ontario.cmha.ca/wp-content/uploads/2016/04/Preventing-Suicide-NTNL-brochure-2014-web.pdf',
		},
		largeContent:
			'Every parent’s nightmare came true for me, the loss of a child. For reasons I will likely never know and will never be understandable, my 13 year old daughter Kaley decided that her life was no longer worth living. Only a week after making her Christmas wish list, talks of shopping for her Grade 8 graduation dress and future plans, Kaley attempted suicide.',
		smallContent:
			'I say “attempted” because she was found before she completed. She had barely any vitals and was taken to hospital. One week after Kaley’s attempt, her body succumbed to her self-inflicted injuries. She had in fact carried out her suicide plan. In the hospital I held Kaley’s unconscious body. I held her hand and talked to her, told her stories, sang her songs, kissed her, hugged her and prayed she would survive this horrible mistake she had made. I held her hand while she faded away from this world, a memory and feeling that haunts me every day. There are no words to describe the loss of a child. Kaley’s death has left me devastated to say the least. My world had crashed in a way I never imagined possible. I wanted to die myself. If it had not been for my 15 year old daughter Makenzie and other loved ones, I wouldn’t have survived this. I had to keep it together for those who needed me. I must somehow take care of myself so I could take care of them.',
		readMore:
			'I was referred to a family case manager with CMHA. Here is where my healing continued. I was able to talk openly and not feel any judgment. I was offered coping strategies and other resources to assist with my journey. I still have many times where it is difficult to get out of bed but I know I have supports and a place to connect at CMHA.',
	},
	{
		title: "Emily's Story",
		id: 'emily',
		desktopMore: false,
		img: {
			src: '/img/Emily.jpg',
			alt: 'Emily headshot',
		},
		link: {
			text: 'Youth Support',
			href:
				'https://ontario.cmha.ca/mental-health/child-and-youth-mental-health/',
		},
		largeContent:
			'At eight months old, Emily began her fight. She underwent bypass surgery at Sick Kids Hospital for a heart condition. For the first 5 years of Emily’s life, she returned to Sick Kids every month for a battery of tests. When remembering these days she speaks fondly of the staff and their dedication to children’s health.',
		smallContent:
			'Emily arrived in Barrie at the age of 18 where she moved 7 times in a year and a half. During this time she tended to isolate in her apartment leaving only to go to school where she was upgrading her courses to start the nursing program at Georgian College. During this stressful time she was admitted to the hospital as her hallucinations were becoming increasingly worrisome. From here she was referred to CMHA Case Management. As a result of another hospitalization and her unstable living arrangements she was accepted into the Homelessness Initiative Program. Emily was ecstatic about receiving her own apartment. Emily is also a regular member of RSVP, enjoying the positive social atmosphere and activities. Emily also has been part of the ACT Team where she feels a sense of full support with coping with her schizophrenia diagnosis. Emily is near completing her RPN with the practicum being her last goal to achieve in the program. From the care and support she has received from the professionals around her she is looking forward to working in a field that will allow her to pay it forward.',
	},
];
